// extracted by mini-css-extract-plugin
export default {"container":"Banner__container--ZcrDR","xs":"Banner__xs--Ecqif","sm":"Banner__sm--MRceo","img":"Banner__img--_6YyT"};